<template lang="html">
  <div class="col-12 col-tab-1">
    <success-checkmark2-component></success-checkmark2-component>

    <div class="d-block text-center txt-black">
      <h2 class="f-w-700">Gracias</h2>

      <p class="f-w-600" style="font-size: 1.10rem;">
        Uno de nuestros ejecutivos te contactará para asistirte  <br />
        en el tramite de la portabilidad de tu numero a Skycel.
      </p>
    </div>
  </div>
</template>

<script>
import successCheckmark2Component from '../shared/success-checkmark-component-2.vue';
export default {
  components: {
    successCheckmark2Component
  }
}
</script>
